import { Injectable } from '@angular/core';
import { ProductSearchService, HttpErrorModel } from '@spartacus/core';
import { map, take } from 'rxjs';
import { CustomProductSearchPage } from '../../models/custom-product.model';

@Injectable()
export class CustomProductListEffectsService {

    constructor(
        private productSearchService: ProductSearchService
    ) { }

    handleError(error: HttpErrorModel): CustomProductSearchPage {
        let result: CustomProductSearchPage = {};
        this.productSearchService.getResults()
            .pipe(
                map((data) => ({
                    ...data,
                    breadcrumbs: [],
                    categoryCode: null,
                    currentQuery: null,
                    facets: [],
                    freeTextSearch: null,
                    keywordRedirectUrl: null,
                    pagination: null,
                    products: [],
                    sorts: [],
                    spellingSuggestion: null,
                    success: true,
                    error: error?.details?.at(0)?.message || error?.message,
                } as CustomProductSearchPage)),
                take(1)
            )
            .subscribe((data: CustomProductSearchPage) => (result = data));

        return result;
    }
}
